import { css } from "@compiled/react";

import Skeleton from "@atlaskit/skeleton";
import { token } from "@atlaskit/tokens";

const SkeletonItem = css({
    display: "flex",
    alignItems: "center",
    padding: token("space.200")
});

const AvatarSkeleton = css({
    marginInlineEnd: token("space.200")
});

const TextSkeleton = css({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "4px"
});

const AvatarSkeletonWrapper = css({
    borderRadius: "50%"
});

const NotificationSkeleton = () => (
    <div css={SkeletonItem}>
        <div css={AvatarSkeleton}>
            <div css={AvatarSkeletonWrapper}>
                <Skeleton width="32px" height="32px" />
            </div>
        </div>
        <div css={TextSkeleton}>
            <Skeleton width="60%" height="15px" />
            <Skeleton width="80%" height="15px" />
            <Skeleton width="30%" height="12px" />
        </div>
    </div>
);

export default NotificationSkeleton;
